import {LearningPathProgressState, LearningPathStepStatus} from './learning-path-status';

import type {StepStatus} from './learning-path-status';

export type LearningPathStepLike = {
    status?: StepStatus;
    progressPercent?: number;
};

/**
 * Centralized step status logic:
 * - `google_tracker` is an explicit synthetic step
 * - courses derive completion from `progressPercent` (>= 100)
 */
export function deriveStepStatus(step: LearningPathStepLike): StepStatus {
    const progress = step.progressPercent;
    if (typeof progress === 'number') {
        return progress >= 100
            ? LearningPathStepStatus.Completed
            : LearningPathStepStatus.InProgress;
    }
    if (step.status) {
        return step.status;
    }
    return LearningPathStepStatus.InProgress;
}

export function normalizeProgressPercent(progressPercent?: number): number {
    return typeof progressPercent === 'number' ? progressPercent : 0;
}

export function derivePathProgressState(
    steps: LearningPathStepLike[],
    isEnrolled: boolean,
): LearningPathProgressState {
    if (!isEnrolled) {
        return LearningPathProgressState.NotEnrolled;
    }
    const progresses = steps.map((step) => normalizeProgressPercent(step.progressPercent));
    const allCompleted = progresses.length > 0 && progresses.every((p) => p >= 100);
    if (allCompleted) {
        return LearningPathProgressState.Completed;
    }
    const anyStarted = progresses.some((p) => p > 0);
    return anyStarted ? LearningPathProgressState.InProgress : LearningPathProgressState.NotStarted;
}
